module.exports = __webpack_public_path__ + "static/media/private_practice.571a219b.jpg";